<template>
  <div>
    <filters-button>
      <button-component
        v-if="!isFilterSelected || !areFiltersOpen"
        color="dark"
        @click="handleFiltersClick"
        black
      >
        Filtruj lokalizacje <span v-if="filtersCount">({{ filtersCount }})</span>
      </button-component>
      <button-component
        v-else
        color="dark"
        @click="filter"
        black
      >
        Filtruj teraz <span v-if="filters.length">({{ filters.length }})</span>
      </button-component>
    </filters-button>

    <filters-list
      :available-filters="availableFilters"
      :filters="filters"
      :is-active="areFiltersOpen"
      @toggleFilter="toggleFilter"
      @click="filter"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import { SET_FILTERS, TOGGLE_MODE } from '@/store/mutation-types'

import FiltersButton from '@/containers/Filters/FiltersButton'
import FiltersList from '@/containers/Filters/FiltersList'
import ButtonComponent from '@/components/Button'

export default {
  components: {
    ButtonComponent,
    FiltersButton,
    FiltersList
  },
  data () {
    return {
      filters: [],
      areFiltersOpen: false
    }
  },
  computed: {
    ...mapGetters(['availableFilters', 'filtersCount', 'isTileList']),
    ...mapState({
      activeFilters: state => state.filters.filters
    }),
    isFilterSelected () {
      return this.filters.length || this.filtersCount
    }
  },
  watch: {
    activeFilters () {
      this.setInternalFilters()
      this.replaceQuery()
    },
    $route (to, from) {
      to.name === 'map' && from.name !== 'home' && this.replaceQuery()
      to.name === 'details' && this.areFiltersOpen && this.toggleFilters()
    }
  },
  created () {
    this.fetchAvailableFilters()
    this.setFilters(this.filtersQueryToArray())
  },
  methods: {
    ...mapActions(['fetchAvailableFilters']),
    ...mapMutations({ setFilters: SET_FILTERS, toggleMode: TOGGLE_MODE }),
    setInternalFilters () {
      this.filters = this.activeFilters
    },
    toggleFilters () {
      this.areFiltersOpen = !this.areFiltersOpen
    },
    handleFiltersClick () {
      if (this.$route.name !== 'map') {
        this.$router.push({ name: 'map' })
      }

      if (this.isTileList) {
        this.toggleMode()
      }

      this.areFiltersOpen = !this.areFiltersOpen
    },
    filter () {
      this.areFiltersOpen = false
      this.setFilters(this.filters)
    },
    toggleFilter (filter) {
      this.filters = this.filters.find(item => item === filter)
        ? this.filters.filter(item => item !== filter)
        : [...this.filters, filter]
    },
    parseFiltersQuery () {
      return this.activeFilters.join(',')
    },
    filtersQueryToArray () {
      const { filters } = this.$route.query
      return filters ? filters.split(',') : []
    },
    replaceQuery () {
      const { query = {} } = this.$route
      this.$router.replace({
        query: {
          ...query,
          filters: this.parseFiltersQuery() || undefined
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Filters/FiltersContainer.vue